// Roadmap layers (L0 → L3) shown in the Vision section.

export interface Layer {
  ix: 'L0' | 'L1' | 'L2' | 'L3';
  nm: string;
  desc: string;
  st: string;
  cls: 'now' | 'next' | 'future' | '';
}

export const LAYERS: Layer[] = [
  { ix: 'L0', nm: 'le fil',       desc: 'réseau social musical cross-plateforme',                 st: 'v0 · 2026', cls: 'now' },
  { ix: 'L1', nm: 'le graphe',    desc: 'amis · artistes · concerts · disquaires · lieux',        st: '2027 →',    cls: 'next' },
  { ix: 'L2', nm: 'le protocole', desc: 'infrastructure ouverte, décentralisée, open-source',     st: 'horizon',   cls: 'future' },
  { ix: 'L3', nm: "l'écosystème", desc: 'applications tierces · clients indépendants · clubs',    st: '→',         cls: '' },
];
